import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  MenuItem,
  CircularProgress
} from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import $ from "jquery";
import apiURL from "../../config/environment";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import { isNumberPositiveInt } from "../../utils";
import CheckIcon from "@mui/icons-material/Check";
import {ScheduleSelect} from "./ScheduleSelect";

export const AddBikeCounterDialog = ({
  open,
  handleClose,
  existingRows,
  setExistingRows,
    schedules
}) => {
  const [ecoCounterId, setEcoCounterId] = useState("");
  const [location, setLocation] = useState("");
  const [trailType, setTrailType] = useState("");
  const [archived, setArchived] = useState(false);
  const [ecoCounterIdError, setEcoCounterIdError] = useState(false);
  const [saveError, setSaveError] = useState(false);
  const [saving, setSaving] = useState(false);
  const [scheduleId, setScheduleId] = useState(null);

  const handleDialogClose = () => {
    setEcoCounterId("");
    setLocation("");
    setTrailType("");
    setArchived(false);
    setSaveError(false);
    setEcoCounterIdError(false);
    setScheduleId(null);
    handleClose();
  };

  useEffect(() => {
    isNumberPositiveInt(ecoCounterId, "Counter ID", setEcoCounterIdError, true);
  }, [ecoCounterId]);

  useEffect(() => {
    if (existingRows.find((row) => row.id === ecoCounterId)) {
      setEcoCounterIdError("Counter ID already exists");
    }
  }, [ecoCounterId]);

  if (!open) return null;

  const handleSave = () => {
    if (
      !isNumberPositiveInt(ecoCounterId, "Counter ID", setEcoCounterIdError)
    ) {
      return;
    }

    if (existingRows.find((row) => row.id === ecoCounterId)) {
      setEcoCounterIdError("Counter ID already exists");
      return;
    }
    setSaving(true);
    const token = JSON.parse(localStorage.getItem("userInfo"))?.token;
    $.ajax({
      method: "POST",
      url: apiURL + "admin/site/ecocounter",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      contentType: "application/json",
      data: JSON.stringify({
        id: ecoCounterId,
        streetName: location,
        trailType: trailType,
        archived: archived,
        scheduleId: scheduleId,
      }),
    })
      .done((data) => {
        setSaving(false);
        setExistingRows([...existingRows, data]);
        handleDialogClose();
      })
      .fail((jqXHR, textStatus, errorThrows) => {
        setSaving(false);
        console.error(
          "Error adding bike counter",
          jqXHR,
          textStatus,
          errorThrows
        );
        setSaveError(true);
      });
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        handleDialogClose();
      }}
    >
      <Box sx={{ width: "444px", padding: "16px 24px 24px 24px" }}>
        <DialogTitle sx={{ padding: 0 }}>New Bike Counter</DialogTitle>
        <DialogContent sx={{ padding: 0 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              marginTop: "16px",
            }}
          >
            {saveError && (
              <Alert severity={"error"}>
                Unable to save. Please try again later.
              </Alert>
            )}
            <TextField
              label="Eco-Counter ID"
              error={ecoCounterIdError ? true : false}
              helperText={ecoCounterIdError}
              onChange={(e) => {
                setEcoCounterId(e.target.value)
                if (existingRows.find((row) => row.id === ecoCounterId)) {
                  setEcoCounterIdError("Counter ID already exists");
                }
              }}
              autoFocus
              value={ecoCounterId}
            />
            <TextField
              label="Location"
              onChange={(e) => setLocation(e.target.value)}
              value={location}
            />
            <FormControl fullWidth>
              <InputLabel id={"trail-type-label"}>Trail Type</InputLabel>
              <Select
                value={trailType}
                labelId={"trail-type-label"}
                label={"Trail Type"}
                onChange={(e) => setTrailType(e.target.value)}
              >
                <MenuItem value="City">City</MenuItem>
                <MenuItem value="Regional">Regional</MenuItem>
              </Select>
            </FormControl>
            <ScheduleSelect
              schedules={schedules}
              value={scheduleId}
              onChange={(e) => setScheduleId(e.target.value)}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ padding: 0, marginTop: "16px" }}>
          <Button
            disabled={saving}
            onClick={() => {
              handleDialogClose();
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            disabled={
              !ecoCounterId || !location || !trailType || ecoCounterIdError || saving
                ? true
                : false
            }
            variant={"contained"}
            sx={{
              backgroundColor: "rgba(19, 151, 203, 1)",
              gap: "8px",
              width: "91.75px",
              height: "36.5px",
            }}
          >
            {saving ? (<CircularProgress size={"24.5px"} />) : (
                <>
                  <CheckIcon sx={{ width: "16px", height: "24px" }} />
                  Save
                </>
            )}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};
